<div class="custom-header-checkbox-class">
    <div class="header-checkbox-class">
<res-custom-checkbox [automationId]="'custom-header-checkbox-input-autoId'" [(ngModel)]="params.headerCheckboxChecked"
                (ngModelChange)="onIsMetadataChanged()" [isIndeterminate]="params.headerCheckboxhasIndeterminateState" [marginLeft]="7">
            </res-custom-checkbox>
        </div>
        <div class="input-section-class"> 
            <input type="text" [disabled]="true">
        </div>
</div>